// Priority numbers from SharePoint come in as "1"–"4" where 1 is the most
// urgent. We surface words in the UI so users don't have to remember the
// scale. Anything already worded (e.g. "High", "Medium") passes through
// unchanged.

const NUMERIC_LABELS: Record<string, string> = {
  "1": "Highest",
  "2": "High",
  "3": "Medium",
  "4": "Low",
};

export function formatPriority(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "";
  const raw = String(value).trim();
  if (!raw) return "";
  // Bare number — map directly.
  if (NUMERIC_LABELS[raw]) return NUMERIC_LABELS[raw];
  // "1 - High" style — pick up the leading digit.
  const m = raw.match(/^([1-4])\b/);
  if (m && NUMERIC_LABELS[m[1]]) return NUMERIC_LABELS[m[1]];
  return raw;
}
